import { render, staticRenderFns } from "./product-testing-report.vue?vue&type=template&id=504764d8&scoped=true&"
import script from "./product-testing-report.vue?vue&type=script&lang=js&"
export * from "./product-testing-report.vue?vue&type=script&lang=js&"
import style0 from "./product-testing-report.vue?vue&type=style&index=0&id=504764d8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504764d8",
  null
  
)

export default component.exports